import * as React from "react";
import { WizardHotelPWAv2Props } from "./typings";
import { inject, observer } from "mobx-react";
import { WizardHotelPWAv2View } from "./WizardHotelPWAv2View";

@inject("wizardState")
@observer
export class WizardHotelPWAv2 extends React.Component<WizardHotelPWAv2Props> {
  constructor(props: WizardHotelPWAv2Props) {
    super(props);

    const hotelWizardState = this.props.wizardState.hotelWizardState;
    hotelWizardState.overrideConfig(() => {
      hotelWizardState.config.elementId = this.props.flexComponent.id;
      hotelWizardState.config.heading.fixedTitle = this.props.flexComponent.model.fixedLobTitle;
      hotelWizardState.config.lastSearch.useLastSearchForSingleLOB = this.props.flexComponent.model.useLastSearchForSingleLOB;
      hotelWizardState.config.enableAddFlight = this.props.flexComponent.model.enableAddFlight;
      hotelWizardState.config.enableAddCar = this.props.flexComponent.model.enableAddCar;
    });
  }

  public render() {
    return <WizardHotelPWAv2View {...this.props} />;
  }
}

export default WizardHotelPWAv2;
